import { c as _c } from "react/compiler-runtime";
import { ReminderEditModalClient } from "@website/accommodation-ui/tour-reminder/reminder-edit-modal";
import { useReminderSwitchBox } from "@website/accommodation-ui/tour-reminder/reminder-switch-box/hooks";
import { UpdateReminderBody } from "@website/accommodation-ui/tour-reminder/types";
import { ReminderSwitchClient } from "@website/ticket-ui/common/components/flight-reminder/reminder-switch-box/reminder-switch";
import { Modal } from "@website/ui/modal";
import { SnackBarV2 } from "@website/ui/snackbar-v2";
interface Properties {
  reminderId?: number;
  reminderArray?: Array<UpdateReminderBody>;
  refetch: () => Promise<void>;
  origin: string;
  dest: string;
  stDate: string;
  rtDate: string;
}
export const ReminderSwitchBoxClient = t0 => {
  const $ = _c(26);
  const {
    reminderId,
    reminderArray,
    refetch,
    origin,
    dest,
    stDate,
    rtDate
  } = t0;
  let t1;
  if ($[0] !== dest || $[1] !== origin || $[2] !== refetch || $[3] !== reminderArray || $[4] !== reminderId || $[5] !== rtDate || $[6] !== stDate) {
    t1 = {
      reminderId,
      reminderArray,
      refetch,
      origin,
      dest,
      stDate,
      rtDate
    };
    $[0] = dest;
    $[1] = origin;
    $[2] = refetch;
    $[3] = reminderArray;
    $[4] = reminderId;
    $[5] = rtDate;
    $[6] = stDate;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    isActiveReminder,
    onClickReminder,
    openModal,
    onCloseModal,
    snackbar,
    onCloseSnackbar
  } = useReminderSwitchBox(t1);
  let t2;
  if ($[8] !== isActiveReminder || $[9] !== onClickReminder) {
    t2 = <ReminderSwitchClient checked={isActiveReminder} onClick={onClickReminder} />;
    $[8] = isActiveReminder;
    $[9] = onClickReminder;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== onCloseModal || $[12] !== openModal || $[13] !== refetch || $[14] !== reminderArray) {
    t3 = openModal ? <ReminderEditModalClient onClose={onCloseModal} refetch={refetch} reminderArray={reminderArray} /> : null;
    $[11] = onCloseModal;
    $[12] = openModal;
    $[13] = refetch;
    $[14] = reminderArray;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== openModal || $[17] !== t3) {
    t4 = <Modal mobileHeight="auto" open={openModal}>{t3}</Modal>;
    $[16] = openModal;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== onCloseSnackbar || $[20] !== snackbar) {
    t5 = <SnackBarV2 {...snackbar} onClose={onCloseSnackbar} />;
    $[19] = onCloseSnackbar;
    $[20] = snackbar;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t2 || $[23] !== t4 || $[24] !== t5) {
    t6 = <div className="mx-auto cursor-pointer">{t2}{t4}{t5}</div>;
    $[22] = t2;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};